import { IDecoration } from "../_interface/IDecoration";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { BoxSelection } from "./GlobalDecoration"
import MathEngine from "../../utils/MathEngine"
import * as d3 from "d3";

export class DecorationModel extends IDecoration {
    constructor(nameClass) {
        super(nameClass);
        this.boxSelection = new BoxSelection;

        this.dragstarted = function() {
            SingletonFlowchart.clicked = true;
            SingletonFlowchart.selected = this.id;

            d3.select(this).style("stroke", "black");
        };

        this.dragged = function(event, d) {
            SingletonFlowchart.clicked = false;

            d.x = event.x;
            d.y = event.y;

            d3.select(this)
                .raise()
                .attr("x", d.x)
                .attr("y", d.y);
        };

        this.dragended = function() {
            this.cursor = "grab";
            d3.select(this).style("stroke", "none");
            SingletonFlowchart.SaveStatus();
        };

        this.createConnectionPath = function(node, callback) {
            if (node.connectionPack.length > 0) {
                let objConnections = node.connectionPack
                node.connectionPack = new Array();

                objConnections.forEach(obj => {
                    let newConn = this.ctrConnection.loadNode(obj.conn, callback, true)
                    node.connectionPack.push({ conn: newConn, dot: obj.dot })
                });
            }
        }

        this.createSelectorArea = function() {
            try {
                if (!this.node)
                    throw "this.node não instanciado!"
                this.boxSelection.initSelection(this.node);
            } catch (e) {
                throw `Classe ${nameClass}, Metodo createSelectorArea().\n${e}`;
            }
        }

        this.disappear = () => {
            let node = d3.selectAll(`#${this.node.idName}`)
            node.remove()
        };

        this.setReadyOnly = () => {
            // d3.selectAll(`g#${this.node.idName} > image`).style("cursor", "crosshair")

            d3.selectAll(`g#${this.node.idName} > text`).style("cursor", "crosshair")
            d3.selectAll(`g#${this.node.idName} > rect`).style("cursor", "crosshair")
            d3.selectAll(`g#${this.node.idName} > circle`).style("cursor", "crosshair")
            d3.selectAll(`g#${this.node.idName} > path`).style("cursor", "crosshair")
            d3.selectAll(`g#${this.node.idName}`).style("cursor", "crosshair")
            d3.selectAll(`g#${this.node.idName} > .selectable`).style("cursor", "pointer")

        }

        this.reloadProperties = () => {
            try {
                 this.node.data.forEach(p => {
                     d3.select(`#${p.id}`)
                         .text(p.text())
                         .node();
                 })
            } catch (e) {
                throw `Classe ${nameClass}, Metodo reloadProperties().\n${e}`;
            }
        };

        this.setOnClick = () => {
            try {
                if (this.node.readOnly && this.node.data && this.node.data.length) {
                    return this.dialog(this.node);
                }

                return null;
            } catch (e) {
                throw `Classe ${nameClass}, Metodo setOnClick().\n${e}`;
            }
        }

        this.setDoubleClick = () => {
            try {
                if (!this.node.readOnly) {
                    return this.dialog(this.node);
                }

                return null;
            } catch (e) {
                throw `Classe ${nameClass}, Metodo setDoubleClick().\n${e}`;
            }
        }

        this.isInvisible = function() {
            let result = MathEngine.sentence(this.node.expressionVisible)
            // console.log('this.node.expressionVisible, result, node :>> ', this.node.expressionVisible, result, this.node);
            if (this.node.expressionVisible && result.value != -9999 && !result.value && this.node.readOnly) {
                this.disappear();
            } else if (!this.node.isVisible()) {
                this.node.decorate(this.dialog);
            }
        }

        this.applyProperties = function (resize) {
            try {
                resize.move(this.node)

                let difX = this.node.width - resize.lastWidth 
                let difY = this.node.height - resize.lastHeight 

                resize.expandX({x: this.node.x + difX, y: this.node.y + difX }, this.node)
                resize.expandY({x: this.node.x + difY, y: this.node.y + difY }, this.node)
            } catch (e) {
                throw `Classe ${nameClass}, Metodo applyProperties().\n${e}`;
            }
        }
    }
}